import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';
import { EmotionUtils, TopEmotion } from '@/utils/emotion-detector';

import { ConfirmButton, ConfirmQuestion, EmotionDisplay, OrPickText, StyledButton } from '../styles';

interface ConfirmPromptProps {
	emotion: TopEmotion;
	onConfirm: () => void;
}

export default function ConfirmPrompt({ emotion, onConfirm }: ConfirmPromptProps) {
	const { formatMessage } = useIntl();

	return (
		<>
			<ConfirmQuestion>
				<Text el="p">{formatMessage(messages.cameraConfirmEmotionQuestion)}</Text>
				<EmotionDisplay>
					<Text el="span">{EmotionUtils.getEmotionEmoji(emotion)}</Text>
					<Text el="span">{emotion}</Text>
				</EmotionDisplay>
			</ConfirmQuestion>

			<ConfirmButton>
				<StyledButton onPress={onConfirm}>{formatMessage(messages.cameraConfirmDetected)}</StyledButton>
			</ConfirmButton>

			<OrPickText>
				<Text el="p" style={{ fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
					{formatMessage(messages.cameraConfirmOrPick)}
				</Text>
			</OrPickText>
		</>
	);
}
